'use strict';
namespace TR {

    import IScope = angular.IScope;
    import ResourceService = Core.ResourceService;
    import TripService = Core.TripService;

    interface RouteParams extends ng.route.IRouteService {
        tripId: string;
        productId: string;
    }

    class CrossSellInsurance {

        noneInsurance: Core.Insurance.SelectedInsurance = { QuoteId: '-1' };
        insuranceAvailabilityBusy = false;
        insuranceQuoteDescription : string | null;
        documentPaths = {};
        insurance: Core.Insurance.SelectedInsurance;
        viewInfo: (quoteId: string, $event: Event) => void;
        insuranceQuotes: Core.Insurance.InsuranceQuote[];
        hasPpPrices: boolean;
        currentInfoId: string;
        isHotelJourney: boolean;
        dates: {
            arrivalDate: Date | string;
            departureDate: Date | string;
        };
        showTotal = false;
        showFrom = true;
        priceTotal: number;
        showCoverDetails = false;
        noSuperQuotes = false;
        onUpdate:Function;
        singleVat = false;
        multipleVat = false;

        constructor($filter,
                    $routeParams: RouteParams,
                    $scope: IScope,
                    arrayUtil,
                    basketService,
                    basketStore,
                    insuranceService,
                    broker: Core.Broker,
                    resourceService: ResourceService,
                    tripService: TripService) {

            broker.subscribe('crossSellInsurance', 'ShowInsuranceTotalPrice', () => {
                this.showTotal = true;
            });

            broker.subscribe('crossSellInsurance', 'ShowInsuranceCoverDetails', () => {
                this.showCoverDetails = true;
            });

            broker.subscribe('crossSellInsurance', 'HideInsuranceSuperQuote', () => {
                this.noSuperQuotes = true;
                this._removeSuperQuotes();
            });

            tripService.getTrip($routeParams.tripId).then((trip: Core.Trip.TripState) => {
                const basketId = trip.BasketId;
                const tripId = trip.TripId;
                let insuranceSearchId = trip.InsuranceRequest ? trip.InsuranceRequest.AvailabilitySearchId : null;

                basketStore.insurance(basketId, $routeParams.productId).then(results => {
                    const insurance = results || this.noneInsurance;
                    this.insurance = angular.copy(insurance);

                    const _updateSubtitle = () => {
                        if (this.insuranceQuotes && _.get(this, 'insurance.QuoteId', false)) {
                            const insuranceQuote = arrayUtil.first(this.insuranceQuotes, i => {
                                return angular.equals(i.QuoteId, this.insurance.QuoteId);
                            });
                            this.insuranceQuoteDescription = insuranceQuote ?
                                `${insuranceQuote.AdultCount + insuranceQuote.ChildCount + insuranceQuote.InfantCount
                                    } x ${insuranceQuote.QuoteType.Destination} - ${insuranceQuote.QuoteType.Scheme
                                    } ${insuranceQuote.QuoteType.Type
                                    } (${resourceService.get('FROM')} ${$filter('customCurrency')(insuranceQuote[
                                        TRPCONFIG.Domain.InsurancePerPersonPricing ?
                                            'PerPersonPrice' :
                                            'Price'
                                    ])} ${resourceService.get('PERPERSON_ABBREVIATION')})`
                                : null;
                        }
                    };

                    if (TRPCONFIG.Domain.CrossSellInsuranceEnabled) {

                        const getInsurance = (insuranceSearchId, params) => {
                            this.insuranceAvailabilityBusy = true;
                            return basketService.getInsuranceQuotes(insuranceSearchId, basketId, tripId, params)
                                .then(insuranceQuotes => {
                                    if (insuranceQuotes != null && insuranceQuotes.length > 0) {
                                        this.insuranceQuotes = insuranceQuotes;
                                        this.hasPpPrices = !!insuranceQuotes[0].PerPersonPrice;
                                        if (insuranceQuotes && insurance.Options) {
                                            const key = insuranceService
                                                .decomposeOptionId(insurance.Options[0].OptionId);
                                            this.insurance = angular.copy(arrayUtil.first(this.insuranceQuotes, i => {
                                                return i.SupplierId === key.supplierId
                                                    && i.QuoteType.TypeId === key.typeId
                                                    && i.QuoteType.SchemeId === key.schemeId
                                                    && (i.QuoteType.RelationshipId === key.relationshipId
                                                                                    || key.relationshipId === 0);
                                            }));
                                        }
                                        if (this.noSuperQuotes) {
                                            this._removeSuperQuotes();
                                        }
                                    }
                                    this.singleVat = insuranceService
                                                        .isVatMessageInclusive(this.insuranceQuotes, false);
                                    this.multipleVat = insuranceService
                                                        .isVatMessageInclusive(this.insuranceQuotes, true);
                                    _updateSubtitle();
                                    this.insuranceAvailabilityBusy = false;
                                },
                                error => {
                                    this.insuranceAvailabilityBusy = false;
                                    this.insuranceQuotes = [];
                                }
                            );
                        };

                        if (this.isHotelJourney) {
                            basketStore.hotel(basketId)
                                .then(hotel => {
                                    this.dates = {
                                        arrivalDate: _.get<string>(hotel, 'Details.Itinerary.CheckInDate'),
                                        departureDate: _.get<string>(hotel, 'Details.Itinerary.CheckOutDate')
                                    };
                                    getInsurance(null, {
                                        airport: _.get(hotel, 'Details.LinkedAirports[0]'),
                                        dates: this.dates
                                    });
                                });
                        }

                        if (insuranceSearchId || !this.isHotelJourney) {
                            getInsurance(insuranceSearchId, {});
                        }

                        //get the document paths
                        this.documentPaths = insuranceService.getDocumentPaths();

                        $scope.$watch('ins.insurance.QuoteId', (val, old) => {
                            if (val == null || old === undefined) {
                                if (val || val === -1) {
                                    this.onUpdate({ value: true, type: 'insurance' });
                                };
                                return;
                            }
                            _updateSubtitle();
                            if (val !== this.noneInsurance.QuoteId) {
                                const quote = arrayUtil.first(this.insuranceQuotes, i => {
                                    return i.QuoteId === val;
                                });

                                //we need to re-check the trip here in case we have just generated the search id
                                tripService.getTrip(tripId).then(t => {
                                    insuranceSearchId = t.InsuranceRequest.AvailabilitySearchId;
                                    this.onUpdate({ value: false, type: 'insurance'});
                                    return basketService.selectInsurance(quote, insuranceSearchId, basketId)
                                        .then(() => {
                                                basketService.updateBasket();
                                                this.onUpdate({value: true, type : 'insurance'});
                                            }
                                        );
                                });
                            } else {
                                this.onUpdate({ value: false, type: 'insurance'});
                                basketStore.removeInsurance(basketId).then(
                                    () => {
                                        basketService.updateBasket();
                                        this.onUpdate({ value: true, type: 'insurance'});
                                    });
                            }
                        });
                    }
                }).then(null, basketService.restartHolidayWorkflow);

                this.viewInfo = (quoteId, $event) => {
                    $event.preventDefault();
                    $event.stopPropagation();

                    this.currentInfoId = quoteId;
                };
            }, basketService.bookingAlreadyDone(`insurance: '${$routeParams.tripId}'`));

        }

        private _removeSuperQuotes() {
            this.insuranceQuotes = [ _.find(this.insuranceQuotes, ['QuoteType.SchemeId', 1]) ];
        }
    }

    angular
        .module('TR')
        .component('crossSellInsurance', {
            bindings: {
                isHotelJourney: '<',
                onUpdate : '&'
            },
            controller: CrossSellInsurance,
            controllerAs: 'ins',
            templateUrl: 'partials/home/directivetemplate?type=CrossSellInsurance'
        });
}
